var exports = {
  "kL": "x127c5a35--a2578a--container",
  "Ew": "x127c5a35--a2578a--notification",
  "A4": "x127c5a35--a2578a--control",
};

module.exports = exports;
